// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AUTH_BASE = "https://auth.emergentagent.com/";

export function startGoogleSignIn(returnPath) {
  const redirectUrl = window.location.origin + returnPath;
  window.location.href = `${AUTH_BASE}?redirect=${encodeURIComponent(redirectUrl)}`;
}

export const GoogleSignInButton = ({ returnPath, label = "Continue with Google", testid = "google-signin-btn" }) => (
  <button
    type="button"
    onClick={() => startGoogleSignIn(returnPath)}
    data-testid={testid}
    className="w-full flex items-center justify-center gap-3 border border-slate-700 bg-white text-slate-900 py-3.5 text-xs uppercase tracking-[0.2em] font-medium hover:bg-slate-100 transition-colors"
  >
    <svg width="17" height="17" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47a5.4 5.4 0 0 1-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z" />
      <path fill="#34A853" d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09A11.99 11.99 0 0 0 12 24z" />
      <path fill="#FBBC05" d="M5.27 14.29a7.2 7.2 0 0 1 0-4.58V6.62H1.29a11.99 11.99 0 0 0 0 10.76l3.98-3.09z" />
      <path fill="#EA4335" d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.7 0 3.99 2.47 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z" />
    </svg>
    {label}
  </button>
);

export const AuthDivider = ({ text = "or use your email" }) => (
  <div className="flex items-center gap-4 my-6" data-testid="auth-divider">
    <span className="h-px flex-1 bg-slate-800" />
    <span className="text-[10px] uppercase tracking-[0.2em] text-slate-600">{text}</span>
    <span className="h-px flex-1 bg-slate-800" />
  </div>
);
